import { createContext } from 'react';

export const defaultLocale = 'en-US';

export const LocaleContext = createContext<string>(defaultLocale);
